import {ServerIcon} from '@primer/octicons-react'
import type {Environment} from '@github-ui/agent-sessions-types/environment'
import {isAhpVersionSupported} from '@github-ui/ahp-relay/protocol-support'

import type {EnvironmentOption} from './environment-option'

export const AHP_OPTION_PREFIX = 'ahp-environment:'

/** Turns AHP environments into picker options with online/version gating. */
export const buildAhpOptions = (environments: Environment[]): EnvironmentOption[] =>
  environments
    .filter(env => !!env.capabilities?.ahp_version)
    .map(env => {
      const online = env.status === 'online'
      const versionSupported = isAhpVersionSupported(env.capabilities?.ahp_version)
      return {
        id: `${AHP_OPTION_PREFIX}${env.id}`,
        kind: 'ahp' as const,
        label: env.name,
        icon: ServerIcon,
        environmentId: env.id,
        status: env.status,
        disabled: !online || !versionSupported,
        versionSupported,
      }
    })
